import { AlertTriangle, AlertCircle, X } from 'lucide-react'

const TOTAL_API_COUNT = 10

export default function AutoFillWarning({ warnings, onDismiss }) {
  if (!warnings || warnings.length === 0) return null

  const isTotal = warnings.length >= TOTAL_API_COUNT

  return (
    <div
      className={`rounded-lg border p-4 mt-3 ${
        isTotal
          ? 'bg-red-50 border-red-200'
          : 'bg-amber-50 border-amber-200'
      }`}
    >
      <div className="flex items-start gap-3">
        {isTotal ? (
          <AlertCircle className="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" />
        ) : (
          <AlertTriangle className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" />
        )}
        <div className="flex-1 min-w-0">
          <p className={`text-sm font-medium ${isTotal ? 'text-red-800' : 'text-amber-800'}`}>
            {isTotal
              ? "L'enrichissement automatique a échoué."
              : 'Certaines données n\u2019ont pas pu être récupérées automatiquement :'}
          </p>
          {!isTotal && (
            <ul className="mt-1.5 text-sm text-amber-700 list-disc list-inside">
              {warnings.map((w) => (
                <li key={w.key}>{w.label}</li>
              ))}
            </ul>
          )}
        </div>
        <button
          type="button"
          onClick={onDismiss}
          className={`flex-shrink-0 p-1 rounded-md transition ${
            isTotal
              ? 'text-red-500 hover:bg-red-100'
              : 'text-amber-500 hover:bg-amber-100'
          }`}
          aria-label="Fermer"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  )
}
